import * as Yup from 'yup';

export const ProvisionTINValidation = () =>
  Yup.object().shape({
    business_name: Yup.string().trim().required('Business name is required'),
    email: Yup.string().required('Email is required').email('Email must be valid'),
    tin: Yup.string()
      .required('TIN is required')
      .matches(/^1\d{9}$/, 'TIN must be 10 digits and start with 1'),
    vat_number: Yup.string()
      .trim()
      .test(
        'vat-format',
        'VAT must be 15 digits, start with 1 and end with 03',
        (value) => !value || /^1\d{12}03$/.test(value),
      ),
  });
